import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Index = () => import('../components/loginCallback')
const routes = [
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: {
            title: '登录方式',
        }
    }
]
const router = new VueRouter({
    routes
})

/* 全局路由后置守卫 */
router.afterEach(function (to, from) {
    const meta = to.meta || {}
    const title = meta.title || to.name
    document.title = title
})
export default router
